export function loader() {
    const $loader = $(".loader");
    const WIN = $(window);
    const BODY = $("body");
    if (document.cookie.indexOf("loader") == -1) {
        document.cookie = "loader=true; max-age=86400";
        BODY.addClass("is-load");
        WIN.on("load", function () {
            setTimeout(() => {
                $loader.fadeOut(800, function () {
                    BODY.removeClass("is-load");
                });

            }, 3400);
        });
    }

}


// WEBPACK FOOTER //
// ./assets/js/modules/loader.js